import React, { Component } from 'react';
import { Panel, Checkbox } from 'react-bootstrap';
import '../../../content/css/PortfolioAnalysis/FilterPanel.css';
import { Chart as ChartJS } from 'chart.js';

export default class Chart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chartId: this.randomId(),
            chart: null
        }
    }

    componentDidMount() {
        this.renderChart();
        //console.log("Chart: mount!");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.data != prevProps.data) {
            this.renderChart();
        }
    }

    randomId = () => {
        let id = "chart-" + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
        return id;
    }

    renderChart = () => {
        if (this.state.chart != null)
            this.state.chart.destroy();

        var ctx = document.getElementById(this.state.chartId);
        var myChart = new ChartJS(ctx, {
            type: this.props.type,
            data: this.props.data,
            options: this.props.options
        });

        this.setState({ chart: myChart });
    }

    render() {
        return (
            <div className="chart">
                <canvas id={this.state.chartId}></canvas>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/Insights/Chart.js